<template xmlns:cm="http://www.w3.org/1999/xhtml">
    <div>

        <main role="main">

            <div class="container">

                <div class="row mb-5">

                    <div class="col-md-12">

                        <h2 class="mb-3">
                            <i class="fa fa-search"></i>
                            {{$t('text.documentSearch.documentSearchFullText.title')}}
                        </h2>

                        <div class="row mt-2 mb-2">

                            <div class="col-md-12">


                                <div class="form-group mb-3">
                                    <label for="query">{{$t('text.globals.searchQuery')}}</label>
                                    <div class="input-group">

                                        <input id="query" type="text" class="form-control mr-0"
                                               :placeholder="$t('text.globals.searchQuery')" v-model="exampleQuery"
                                               @keyup.enter="submitQuery(true)" autofocus>

                                    </div>
<!--                                    <small><em>{{$t('text.documentSearch.documentSearchFullText.putSearchQueryInQuotesInfo')}}</em></small>-->
                                </div>

                            </div>
                        </div>
                        <div class="row mt-2 mb-2">
                            <div class="col-md-12 text-right">

                              <a class="btn btn-primary text-white" @click="clearSearch()" id="clearFilters"> {{ $t('text.globals.clearAllFilters')}} </a>

                              <a class="btn btn-primary text-white" id="buttonSearchQuery" @click="submitQuery(true)"><i class="fa fa-search"></i> {{ $t('text.globals.search') }} </a>

                            </div>
                        </div>

                      <div class="row" v-if="selectedDocuments.length > 0">
                        <div class="col-md-12">
                          <div class="bg-light p-4">
                            <div>
                              <div class="mb-2"><i class="fa fa-check-square"></i> {{$t('text.documentLists.selectedDocuments')}}: <b>{{selectedDocuments.length}}</b>
                                <a class="btn btn-secondary btn-sm text-white ml-3"
                                   @click="selectAll()">{{ $t('text.documentLists.selectAll') }}</a>
                                <a class="btn btn-secondary btn-sm text-white ml-3"
                                   @click="unselectAll()">{{ $t('text.documentLists.deselectAll') }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                        <div class="row mt-2 mb-2">
                            <div class="col-md-12">
                                <div>
                                    <loading :active.sync="isLoading"
                                             :can-cancel="false"
                                             :is-full-page="false"></loading>

                                    <SearchResultsWithSelection
                                            ref="searchResultsWithSelection"
                                            :searchType="$t('text.documentSearch.documentSearchFullText.title')"
                                            :query="query"
                                            :searchFieldsText="exampleQuery"
                                            :queryResult="queryResult"
                                            :filtersQuery="filtersQuery"
                                            :columns="columns"
                                            :context="context"
                                            :totalRecords="totalRecords"
                                            :serverParams="serverParams"
                                            @clearFiltersQuery="clearFiltersQuery"
                                    ></SearchResultsWithSelection>



                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>

        </main>

    </div>
</template>

<script type="text/javascript">
    import Vue from 'vue';
    import SearchResults from '../components/SearchResults';
    import SearchResultsWithSelection from '../components/SearchResultsWithSelection';
    import axios from 'axios';
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';


    export default {
        name: 'DocumentSearchFullText',
        components: {
            SearchResults,
            SearchResultsWithSelection,
            Loading
        },

        data() {
            return {
                query: '',
                filtersQuery: [],
                allMetadataOptions: [],
                sites: [],
                user: {},
                error: '',

                selectedDocuments: [],
                selectedDocumentsList: [],

                isLoading: false,
                totalRecords: null,
                serverParams: {
                    columnFilters: {},
                    sort: [],
                    page: 1,
                    perPage: this.$store.getters.getItemsPerPage
                },
                queryResult: [],
                context: {},
                columns: _.cloneDeep(this.$globalFunctions.getListColumns('searchResults')),
                exampleQuery: null,
                queryParam: this.$route.params.queryParam && this.$route.params.queryParam != null ? this.$route.params.queryParam : ''
            };
        },

        computed: {

            mimeTypeFacets: function () {
                const _this = this;

                let filtered = _.filter(_this.context.facetsFields, {label: 'mimetype'});

                return filtered.length ? filtered[0].buckets : []
            },

            statusGradivaFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'statusGradiva'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:status_gradiva', parseInt(val.label));
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            klasifikacijskaOznakaRazredaFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'klasifikacijskaOznakaRazreda'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:klasifikacijska_oznaka_razreda', parseInt(val.label));
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            courtFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'sodišče'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:sodisce', val.label);
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            caseReferenceNumberFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'opravilnaŠtevikaZadeve'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:opravilna_stevilka_zadeve', val.label);
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            povezanSistemFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'oznakaPovezanegaSistema'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_povezanega_sistema', val.label);
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            oznakaVpisnikaFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'oznakaVpisnika'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_vpisnika', val.label);
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },

            fizicnoGradivoFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'fizičnoGradivo'});

                return filtered.length ? filtered[0].buckets : []
            },

            rokHrambeFacets: function () {
                const _this = this;
                let filtered = _.filter(_this.context.facetsFields, {label: 'rokHrambe'});

                if (filtered.length) {
                    filtered = _.map(filtered[0].buckets, function (val, key) {
                        val.label = _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:rok_hrambe', parseInt(val.label));
                        return val
                    });
                }

                return filtered.length ? filtered : []
            },


        },

        beforeCreate: function () {

        },

        mounted: function () {
            const _this = this;

            console.log("RoUTE:", _this.$route.params);


            let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");

            Promise.all([p1]).then((values) => {
                _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;

                if (_this.$route.params.queryParam && _this.$route.params.queryParam.length > 0) {
                    _this.exampleQuery = decodeURIComponent(_this.queryParam);
                    _this.submitQuery(true);
                }

            });

        },

        methods: {

            clearSearch() {

                // query fields
                this.exampleQuery = "";

                this.selectedDocuments = [];
                this.$store.dispatch("setSelectedDocuments", []);

                this.filtersQuery = [];
                this.totalRecords = null;
                this.serverParams = {
                  columnFilters: {},
                  sort: [],
                  page: 1,
                  perPage: this.$store.getters.getItemsPerPage
                };
                this.queryResult = [];
                this.context = {};
                this.isLoading = false;
                this.query = '';

                this.columns = _.cloneDeep(this.$globalFunctions.getListColumns('searchResults'));

                // url change
                this.$router.replace({
                  name: 'DocumentSearchFullText'
                }).catch(err => {
                  console.log("err: ", err)
                });

            },

            clearFiltersQuery() {
                this.filtersQuery = [];
            },

            toggleColumn(index, event) {
                this.$set(this.columns[index], 'hidden', !this.columns[index].hidden);
            },

            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);

                console.log("newProps ->>>", newProps);
            },

            onPageChange(params) {
                const _this = this;

                _this.isLoading = true;

                console.log("!!!!!!!onPageChange", params);

                _this.updateParams({page: params});
                setTimeout(function () {
                    _this.submitQuery();
                }, 1)

            },

            onPerPageChange() {

              console.log("!!!!!!!!!onPerPageChange");
                const _this = this;
                _this.updateParams({perPage: _this.$store.getters.getItemsPerPage});
                setTimeout(function () {
                    _this.submitQuery(true);
                }, 1)
            },

            onSortChange(params) {
                console.log("onSortChange", params);
                const _this = this;

                _this.isLoading = true;

                let sort = [];

                _.map(_this.columns, function (item, i) {

                    console.log("item", item, _this.$globalFunctions.formatFieldNameForSort(item.field));

                    if (item.sort && typeof (item.sort.ascending) !== 'undefined') {

                        let sortItem = {
                            'ascending': item.sort.ascending ? 'true' : 'false',
                            'field': _this.$globalFunctions.formatFieldNameForSort(item.field),
                            'type': 'FIELD'
                        };
                        sort.push(sortItem);
                    }
                });


                _this.updateParams({
                    sort: sort,
                });

                setTimeout(function () {
                    _this.submitQuery();
                }, 1);


            },

            onColumnFilter(params) {
              console.log("!!!!!!!!!!!onColumnFilter", params);
                const _this = this;
                _this.updateParams(params);
                setTimeout(function () {
                    _this.submitQuery();
                }, 1)
            },


            submitQuery(newSearch) {


                console.log("QUERYSUBMIT");

                let _this = this;

                _this.isLoading = true;
                _this.queryResult = [];
                _this.selectedDocuments = [];

                // console.log(_this.serverParams);
                // console.log("expressionFromQuery: ", _this.exampleQuery);
                // console.log("skip count: ", (_this.serverParams.page - 1) * _this.serverParams.perPage);
                // console.log("_this.serverParams.sort", _this.serverParams.sort)

                let query = {
                    "query": {
                        "query": _this.exampleQuery != '' && _this.exampleQuery != null ? _this.exampleQuery.replace(/['"$&+,:;=?@#|<>.^*()%!-]/g, (char) => ' ') : '*'
                    },
                    "paging": {
                        "maxItems": _this.serverParams.perPage,
                        "skipCount": newSearch ? 0 : (_this.serverParams.page - 1) * _this.serverParams.perPage
                    },
                    "include": [
                        "properties"
                    ],
                    "fields": [],
                    "sort": this.$globalFunctions.reformatSortArray(_this.serverParams.sort),
                    "facetQueries": this.$t('text.documentSearch.facetQueries'),
                    "facetFields": this.$t('text.documentSearch.facetFields'),
                };

                let filterQueryString = '';

                _.map(_this.filtersQuery, function (val) {
                    filterQueryString += ' AND ' + val;
                });

                query.query.query = '(' + query.query.query + filterQueryString + ') ' + ' AND TYPE:\"cm:content\"' + ' AND ASPECT:\"EH:osnovni_podatki\"';
                _this.query = query.query.query;

                axios.post(config.alfrescoSearchApi, query)
                    .then((res) => {
                        _this.totalRecords = res.data.list.pagination.totalItems;
                        _this.serverParams.page = res.data.list.pagination.skipCount / _this.serverParams.perPage + 1;
                        _this.queryResult = res.data.list.entries;
                        _this.context = res.data.list.context;
                        _this.isLoading = false;

                        setTimeout(function () {
                            document.documentElement.scrollTop = _this.$store.getters.getOffsetTop;
                            _this.$store.dispatch("setOffsetTop", null);
                        }, 1);

                        // console.log("_this.$route.params.queryParam", decodeURIComponent(_this.$route.params.queryParam));
                        // console.log("_this.exampleQuery", _this.exampleQuery);

                        if(_this.exampleQuery) {
                            _this.$router.push({
                                name: 'DocumentSearchFullText',
                                params: {queryParam: encodeURIComponent(_this.exampleQuery)}
                            }).catch(err => {
                            });
                        }
                    })
                    .catch((error) => {
                        console.log("error", error);
                    });


            },

            onRowClick(row) {
                let _this = this;

                console.log(row);
                if(!_this.$globalFunctions.checkForPermission('DOST_DOK_IN_META') && !_this.$globalFunctions.checkForPermission('DOST_DOK_ARHIV')) {
                    console.error("No permission for DOST_DOK_IN_META || DOST_DOK_ARHIV");
                    return
                }

                let id = row.id;

                if (row.isFile) {
                    _this.$router.push("/dokument/" + id)
                } else {
                    Vue.$toast.open({
                        message: this.$t('text.documentSearch.documentSearchDetailed.openingEnabledJustForFilesErrorToast'),
                        type: 'error',
                        position: 'top-right'
                    });
                }

            },

            onCheckboxClick($event, uuid) {
                let _this = this;

                $event.stopPropagation();

                if(_this.selectedDocuments.indexOf(uuid) > -1) {
                    _this.selectedDocuments.splice(_this.selectedDocuments.indexOf(uuid),1);
                } else {
                    _this.selectedDocuments.push(uuid);
                }

                _this.generateSelectedDocumentList();
                _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
            },

            onThCheckboxClick($event) {
                let _this = this;
                $event.stopPropagation();

                const checkboxItem = $event.target.id === "selectAllTh" ? $event.target.querySelector("#selectAllCheckbox") : $event.target;

                if(checkboxItem.checked) {
                    console.log("select all documents!");
                    _.map(_this.queryResult, function (val) {
                        if(_this.selectedDocuments.indexOf(val.entry.id) === -1) {
                            _this.selectedDocuments.push(val.entry.id);
                        }
                    });
                } else {
                    console.log("DEselect all documents!");
                    _this.selectedDocuments = [];
                }

                _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
            },

            generateSelectedDocumentList() {
                const _this = this;
                _this.selectedDocumentsList = [];

                _.map(_this.selectedDocuments, function (val) {
                    _.map(_this.queryResult, function (_val) {
                        if (_val.entry.id === val) {
                            _this.selectedDocumentsList.push(_val.entry);
                        }
                    });
                });
            },

          unselectAll() {
            const _this = this;

            _this.selectedDocuments = [];
            _this.selectedDocumentsList = [];
            _this.$store.dispatch("setSelectedDocuments", []);
            _this.$refs.searchResultsWithSelection.checkIfHeaderCheckboxShouldBeChecked();
          },

          selectAll() {
            const _this = this;

            _.map(_this.queryResult, function (val) {
              if(_this.selectedDocuments.indexOf(val.entry.id) === -1) {
                _this.selectedDocuments.push(val.entry.id);
              }
            });

            _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
          }


        }
    };
</script>



// WEBPACK FOOTER //
// src/pages/DocumentSearchFullText.vue